import QuagganEmoji from "./QuagganEmoji.jsx";

export default function WheelStatusMessage({ message, tone = "success", iconSrc = "", iconAlt = "" }) {
  if (!message) {
    return null;
  }

  const emojiType = tone === "error" ? "failure" : "success";

  return (
    <div className={`wheel-status-message wheel-status-message-${tone}`} aria-live="polite">
      {iconSrc ? (
        <img src={iconSrc} alt={iconAlt || "Added item icon"} className="wheel-status-message-item-icon" />
      ) : null}
      <span className="wheel-status-message-text">{message}</span>
      <QuagganEmoji type={emojiType} inline size={44} className="wheel-status-message-emoji" />
    </div>
  );
}